<template>
  <a-modal v-model="visible" :title="`${appData.name}${$t('接口管理')}`" width="80%" :footer="null">
    <a-card>
      <a-button type="primary" @click="handleUrlAdd">{{ $t('新增') }}</a-button>
      <a-table rowKey="id" :pagination="urlpagination" :columns="urlcolumns" :dataSource="urldataSource" @change="handleUrlTableChange">
        <div slot="action" slot-scope="text, record">
          <a @click="handleUrlEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleUrlDelete(record)">
            <a style="color: red;">{{ $t('删除') }}</a>
          </a-popconfirm>
        </div>
      </a-table>
    </a-card>
    <a-card>
      <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
      <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="dataSource" @change="handleTableChange">
        <div slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
            <a style="color: red;">{{ $t('删除') }}</a>
          </a-popconfirm>
        </div>
      </a-table>
    </a-card>
    <AppApiEditModal ref="modal" @ok="handleOK" />
    <AppApiUrlEditModal ref="url" @ok="handleUrlOK" />
  </a-modal>
</template>
<script>
import { getApiList, deleteApiByIds } from '@/api/app/apimanage'
import AppApiEditModal from './AppApiEditModal.vue'
import AppApiUrlEditModal from './AppApiUrlEditModal.vue'
import { getApiUrlList, deleteApiUrlByIds } from '@/api/app/apiurl'
import { getLabelFromOptions } from '@/utils/dictUtils'

export default {
  components: {
    AppApiEditModal,
    AppApiUrlEditModal
  },
  data() {
    return {
      visible: false,
      dataSource: [],
      urldataSource: [],
      queryParams: {},
      appData: {},
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
      urlpagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('接口名称'),
          dataIndex: 'name'
        },
        {
          title: this.$t('模块'),
          dataIndex: 'module'
        },
        {
          title: this.$t('HTTP方法'),
          dataIndex: 'httpMethod'
        },
        {
          title: this.$t('接口地址'),
          dataIndex: 'apiUrl',
          customRender: (text, record) => {
            return '/appeditor/apimanage/handle/request/' + record.id
          }
        },
        {
          title: this.$t('接口类型'),
          dataIndex: 'actionType'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
      ]
    },
    urlcolumns() {
      return [
        {
          title: this.$t('类型'),
          dataIndex: 'type',
          customRender: (text) => {
            return getLabelFromOptions(text, this.urltypeOptions, text)
          }
        },
        {
          title: this.$t('地址'),
          dataIndex: 'apiUrl'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
      ]
    },
    urltypeOptions() {
      return [{ label: this.$t('测试环境'), value: 'dev' }, { label: this.$t('预发布环境'), value: 'beta' }, { label: this.$t('生产环境'), value: 'prod' }]
    }
  },
  methods: {
    show(data) {
      this.appData = { ...data }
      this.pagination.total = 0
      this.pagination.current = 1
      this.urlpagination.total = 0
      this.urlpagination.current = 1
      this.dataSource = []
      this.urldataSource = []
      this.queryParams = {}
      this.refresh()
      this.refreshUrl()
      this.visible = true
    },
    handleAdd() {
      this.$refs.modal.show(this.appData, {})
    },
    handleEdit(record) {
      this.$refs.modal.show(this.appData, record)
    },
    handleDelete(record) {
      deleteApiByIds([record.id]).then(res => {
        if (res.code === 0) {
          this.refresh()
        } else {
          this.$message.error(res.message || this.$t('删除失败'))
        }
      })
    },
    handleOK(data) {
      if (!data.id) {
        this.pagination.current = 1
      }
      this.refresh()
    },
    refresh() {
        this.loadTableData({ pageNum: this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getApiList({ ...params, appId: this.appData.id }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.dataSource = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    },
    handleUrlAdd() {
      this.$refs.url.show(this.appData, {})
    },
    handleUrlEdit(record) {
      this.$refs.url.show(this.appData, record)
    },
    handleUrlDelete(record) {
      deleteApiUrlByIds([record.id]).then(res => {
        if (res.code === 0) {
          this.refreshUrl()
        } else {
          this.$message.error(res.message || this.$t('删除失败'))
        }
      })
    },
    handleUrlOK(data) {
      if (!data.id) {
        this.urlpagination.current = 1
      }
      this.refreshUrl()
    },
    refreshUrl() {
        this.loadUrlTableData({ pageNum: this.urlpagination.current, pageSize: this.urlpagination.pageSize })
    },
    loadUrlTableData(params) {
      getApiUrlList({ ...params, appId: this.appData.id }).then(res => {
        if (res.code === 0) {
          this.urlpagination.current = res.data.pageNum
          this.urlpagination.total = res.data.total
          this.urldataSource = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleUrlTableChange(page) {
      if (page.current == this.urlpagination.current) {
        return
      }
      this.loadUrlTableData({ pageNum: page.current, pageSize: page.pageSize })
    }
  }
}
</script>